import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';
import gsap from "gsap"
import ScrollTrigger from 'gsap/ScrollTrigger';
import FormManager from './FormManager';
import usefull from './useful';

/*
data-popin-open = true | false // etat de la popin
data-popin-button = "recrut" | "contact" //type de popin à ouvrir
data-popin-id = "recrut" | "contact"  // DOM à afficher
*/
gsap.registerPlugin(ScrollTrigger)


export default class Popins {
    constructor(id = "contact") {
        this.id = id;
        this.DOM = document.querySelector(`[data-popin-id=${id}]`)
        // 
        const buttonsOpen = document.querySelectorAll(`[data-popin-button=${id}]`);
        const buttonsClose = document.querySelectorAll(`[data-popin-close=${id}]`);

        buttonsOpen.forEach(
            (button) => {
                button.addEventListener("click", () => {
                    this.open(this.id)
                })

                button.removeEventListener("click", () => {
                    this.open(this.id)
                })
            }
        )

        buttonsClose.forEach(el => el.onclick = () => {
            this.close(this.id)
        })


        if (document.querySelector(".c-form")) {
            new FormManager()
        }

    }

    open(id) {
        const popin = document.querySelector(`[data-popin-id=${id}]`)
        popin.setAttribute("data-popin-open", true)
        this.animateOpen(popin);
        document.querySelector('.c-popins__wrapper').scrollTo(0,0);

        !usefull.isMobile() && disableBodyScroll(this.DOM)
    }

    close(id) {
        const popin = document.querySelector(`[data-popin-id=${id}]`);
        popin.removeAttribute("data-popin-open")
        

        enableBodyScroll(this.DOM)
    }

    animateOpen(popin) {
        const title = popin.querySelector(`.t-popin-form__title`);
        const intro = popin.querySelector(`.t-popin-form__intro`)
        const image = popin.querySelector(`.t-popin-form__side__img`)
        const form = popin.querySelector(`.t-popin-form__form`)
        // apparition des titres, intro, image
        gsap.from([title, intro, image, form], {
            autoAlpha: 0,
            opacity: 1,
            y: 100,
            delay: .2,
            duration: .5,
            stagger: 0.25
        })

        // apparition du formulaire un par un des elements en fonction du scroll
        const elementsToAnimate = this.DOM.querySelectorAll('.t-popin-form__mailto, fieldset > *');
        gsap.from(elementsToAnimate, {
            scrollTrigger: popin,
            autoAlpha: 0,
            y: 20,
            duration: .35,
            delay: 0.3,
            stagger: 0.15,
        })

    }
}